import React from 'react';
import ScrollTop from "./ScrollTop";
import { Link } from "react-scroll";
import { FaAndroid, FaDiscord, FaApple} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Logo from '../../elements/logo/Logo';
export const getFlag = (lang) => `/icons/icon-lang-${new String(lang).toLowerCase().split("-")[0]}.png`;


const FooterTwo = () => {
    const { t, i18n } = useTranslation('community');
    const handleChange = (event) => {
      i18n.changeLanguage(event.target.value);
    };
    return (
        <>
            <footer className="rn-footer footer-style-default variation-two">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            {/* Start Principle Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="logo pb-4">
                                        <Logo 
                                            image={`${process.env.PUBLIC_URL}/coimages/logo/noizet-dark.png`}
                                            image2={`${process.env.PUBLIC_URL}/coimages/logo/noizet-light.png`}
                                        />
                                    </div>
                                    <p>{t('footer.resume')}</p>
                                </div>
                            </div>
                            {/* End Principle Widget  */}

                            {/* Start One-stop shop Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="widget-menu-top">
                                        <h4 className="title">{t('footer.offres')}</h4>
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                <li><Link to="offers" smooth={true} offset={-70} duration={500}>{t('footer.epargneSalariale')}</Link></li>
                                                <li><Link to="offers" smooth={true} offset={-70} duration={500}>{t('footer.capital')}</Link></li>
                                                <li><Link to="offers" smooth={true} offset={-70} duration={500}>{t('footer.cse')}</Link></li>
                                                <li><Link to="offers" smooth={true} offset={-70} duration={500}>{t('footer.primesBonus')}</Link></li>
                                                <li><Link to="offers" smooth={true} offset={-70} duration={500}>{t('footer.donations')}</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End One-stop shop Widget  */}

                            {/* Start About Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{t('footer.usefulinks')}</h4>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            <li><Link to='home' smooth={true} offset={-70} duration={500}>Home</Link></li>
                                            <li><Link to="mission" smooth={true} offset={-70} duration={500}>{t('header.entrepriseMission')}</Link></li>
                                            <li><Link to="benefits" smooth={true} offset={-70} duration={500}>{t('header.avantages')}</Link></li>
                                            <li><Link to="functioning" smooth={true} offset={-70} duration={500}>{t('header.fonctionnement')}</Link></li>
                                            <li><Link to="offers" smooth={true} offset={-70} duration={500}>{t('header.offres')}</Link></li>
                                            <li><Link to="contactform" smooth={true} offset={-70} duration={500}>{t('buttons.beContacted')}</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* End About Widget  */}

                            {/* Start Single Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <h4 className="title">{t('footer.staywith')}</h4>
                                    <div className="inner">
                                        <h6 className="subtitle">{t('footer.feelfree')}</h6>
                                        <ul className="social-icon social-default justify-content-start mb-4">
                                            <li><Link to="#"><FaDiscord /></Link></li>
                                            <li><Link to="#"><FaApple /></Link></li>
                                            <li><Link to="#"><FaAndroid /></Link></li>
                                        </ul>
                                        <li className='d-flex text-center'>
                                            <img style={{width:"20px",height:"20px"}} alt="" src={`${process.env.PUBLIC_URL + getFlag(i18n.language)}`} />
                                            <select style={{fontSize:"12px",lineHeight:"10px",borderRadius:"0px",background:"transparent",height:"auto",padding:"0px",width:"60px",textAlign:"center"}} name="lang" onChange={handleChange}>
                                                {i18n.languages.map((lang) => {
                                                return (
                                                    <option className="dark:tw-text-black" key={lang} value={lang}>
                                                    {lang}
                                                    </option>
                                                );
                                                })}
                                            </select>
                                        </li>
                                    </div>
                                </div>
                            </div>
                            {/* End Single Widget  */}
                        </div>
                    </div>
                </div>
            </footer>
            <ScrollTop />
        </>
    )
}

export default FooterTwo;
